module.exports = __webpack_public_path__ + "media/Slay.590735e0.mp3";